import Backbone from 'backbone';

abstract class BufferOptionsView<T extends Backbone.Model> extends Backbone.View<T> {
  abstract removeAsync(afterRemove: () => void): BufferOptionsView<T>;
}

export default BufferOptionsView;
